import { IsEmail, IsNotEmpty, IsOptional } from "@pineapplelab/validators";


export class MailDataDto {
    @IsNotEmpty()
    name: string;

    @IsNotEmpty()
    lastName: string;

    @IsNotEmpty()
    message: string;

    @IsEmail()
    @IsNotEmpty()
    email: string;

    @IsEmail()
    @IsNotEmpty()
    emailFrom: string;

    @IsOptional()
    phone?: string

    @IsOptional()
    jobOfferPosition?: string

    fromJson(json: any): MailDataDto {
        return Object.assign(new MailDataDto(), json);
    }
}
